import script from "./FooterModel.vue?vue&type=script&setup=true&lang=js"
export * from "./FooterModel.vue?vue&type=script&setup=true&lang=js"

import "./FooterModel.vue?vue&type=style&index=0&id=f9ef4a66&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f9ef4a66"]])

export default __exports__